module.exports = __webpack_public_path__ + "static/media/calendar-scheduled.ba155171.svg";